import styled from 'styled-components/native'
import webstyled from 'styled-components'

import StyleVariables from '../../../StyleVariables'

export const ListCardContainer = styled.View<{
    highlight: string
    isChild: boolean
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    padding: ${({ isChild }) => isChild ? '5px 35px 5px 15px' : '5px 0 5px 0'};
    margin: 15px 0;
    width: 100%;
`

export const ListImage = styled.Image`
    height: ${({ isChild }) => isChild ? '40px' : '48px'};
    width: ${({ isChild }) => isChild ? '40px' : '48px'};
    border-radius: 28px;
    background-color: ${({ highlight }) => (highlight || '#FFF')};
`

export const ListColor = styled.View<{
    color: string
}>`
    height: ${({ isChild }) => isChild ? '40px' : '48px'};
    width: ${({ isChild }) => isChild ? '40px' : '48px'};
    border-radius: 24px;
    background-color: ${({ color }) => color};
`

/**
 * OB-499: Plain <div>. Click handling moved to the outer CardNavWrapper.
 * `display: flex; flex-direction: column;` restores the implicit column
 * stacking that the previous `styled(TouchableOpacity)` (a RN View under the
 * hood) gave for free — without it, RN-Web Text children render inline and
 * collapse onto one line (OB-503).
 */
export const ListCardTextContainer = webstyled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 4;
    max-width: 200px;
    margin-left: 24px;
`

export const ListCardTitle = styled.Text<{
    highlight: string
}>`
    font-size: 16px;
    margin-bottom: 8px;
    color: ${({ highlight }) =>
    highlight || StyleVariables.colorGrey};
    font-weight: bold;
    width: fit-content;
`

export const ListCardText = styled.Text<{
    fontcolor: string
}>`
    font-size: 16px;
    color: ${({ fontcolor }) =>
    fontcolor || StyleVariables.colorGrey};
`

export const ListCardDate = styled.Text<{
    highlight: string
}>`
    font-size: 14px;
    margin-bottom: 8px;
    color: ${({ highlight }) =>
    highlight || StyleVariables.colorGrey};
    font-weight: bold;
`


/**
 * OB-499: Plain <div>. Was styled(TouchableOpacity) but no onPress was ever
 * attached by any consumer.
 */
export const ListMetaContainer = webstyled.div`
    flex-direction: row;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
    display: flex;
`

export const ListCardPrice = styled.Text<{
    highlight: string
}>`
    font-size: 16px;
    margin-top: 8px;
    color: ${({ highlight }) =>
    highlight || StyleVariables.colorGrey};
    font-weight: bold;
`

export const ContentLine = styled.View<{
    lineColor: string
}>`
    border-bottom-width: 2px;
    border-bottom-color: ${({ lineColor }) => lineColor};
    margin: 4px 0;
`
